import { Routes, Route } from "react-router-dom";
import {
  LayoutDashboard, ClipboardList, UtensilsCrossed, Layers, QrCode, BarChart3, Users, Settings as SettingsIcon, CreditCard, Clock,
} from "lucide-react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { OrdersBoard } from "@/components/orders/OrdersBoard";
import { useAuth } from "@/context/AuthContext";
import Overview from "./Overview";
import Products from "./Products";
import Categories from "./Categories";
import Customizations from "./Customizations";
import Tables from "./Tables";
import Reports from "./Reports";
import Staff from "./Staff";
import Settings from "./Settings";
import Subscription from "./Subscription";

const NAV = [
  { to: "/dashboard", key: "overview", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/dashboard/orders", key: "orders", label: "Orders", icon: ClipboardList },
  { to: "/dashboard/products", key: "products", label: "Menu items", icon: UtensilsCrossed },
  { to: "/dashboard/categories", key: "categories", label: "Categories", icon: Layers },
  { to: "/dashboard/customizations", key: "customizations", label: "Add-ons & variations", icon: Layers },
  { to: "/dashboard/tables", key: "tables", label: "Tables & QR", icon: QrCode },
  { to: "/dashboard/reports", key: "reports", label: "Reports", icon: BarChart3 },
  { to: "/dashboard/staff", key: "staff", label: "Staff", icon: Users },
  { to: "/dashboard/subscription", key: "subscription", label: "Subscription", icon: CreditCard },
  { to: "/dashboard/settings", key: "settings", label: "Settings", icon: SettingsIcon },
];

function StatusBanner({ status }) {
  if (status === "active") return null;
  const msg = {
    pending: "Your restaurant is awaiting Super Admin approval. You can set up your menu now — it goes live once approved.",
    suspended: "Your restaurant is suspended. The public menu and ordering are disabled. Contact support.",
    rejected: "Your registration was rejected. Please contact support for details.",
  }[status];
  return (
    <div className="mb-6 flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800" data-testid="restaurant-status-banner">
      <Clock className="mt-0.5 h-4 w-4 shrink-0" /> {msg}
    </div>
  );
}

export default function OwnerDashboard() {
  const { restaurant } = useAuth();
  return (
    <DashboardLayout nav={NAV} publicSlug>
      <StatusBanner status={restaurant?.status} />
      <Routes>
        <Route index element={<Overview />} />
        <Route path="orders" element={<OrdersBoard />} />
        <Route path="products" element={<Products />} />
        <Route path="categories" element={<Categories />} />
        <Route path="customizations" element={<Customizations />} />
        <Route path="tables" element={<Tables />} />
        <Route path="reports" element={<Reports />} />
        <Route path="staff" element={<Staff />} />
        <Route path="subscription" element={<Subscription />} />
        <Route path="settings" element={<Settings />} />
      </Routes>
    </DashboardLayout>
  );
}
